import { SortableContext, SortingStrategy } from '@dnd-kit/sortable';
import { IContainerWidget, Widget } from '@framework/engine';
import React, { useMemo } from 'react';
import { WidgetColumn } from './layout/WidgetColumn';
import { WidgetRow } from './layout/WidgetRow';
import { SortableWidget } from './sortable-widgets/SortableWidget';

// const WidgetLeafWidth = styled.div<{ width?: number }>`
//   display: block;
//   width: 100%;
//   position: relative;
//   padding-left: 6px;
//   padding-right: 6px;

//   ${props =>
//     props.width &&
//     css`
//       display: ${props.width === 100 ? 'block' : 'flex'};
//       flex: 0 0 ${props.width}%;
//       min-width: 0;
//       width: ${props.width}%;
//     `}
// `;

export interface ISortableWidgetListProps {
  strategy?: SortingStrategy;
  widgets: Widget[];
  parent?: Widget & IContainerWidget;
}

/**
 * Lista di tutti i widget con drag and drop, circondati dal sortable context.
 */
export function SortableWidgetList(props: ISortableWidgetListProps) {
  const { widgets, parent } = props;

  const itemIds = useMemo(() => widgets.map(widget => widget.id!), [widgets]);
  return (
    <SortableContext items={itemIds} strategy={props.strategy}>
      <WidgetRow>
        {widgets.map(widget => (
          <WidgetColumn parent={parent} widget={widget} key={widget.id}>
            <SortableWidget key={widget.id} widget={widget} parent={parent} />
          </WidgetColumn>
        ))}
      </WidgetRow>
    </SortableContext>
  );
}
